export default "__VITE_ASSET__DmkSKFzh__"